import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const Tests = () => {
    const { apipath, logout, goBack, filepath } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [tests, setTests] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const [isFileOpen, setIsFileOpen] = useState(false);
    const [selectedTest, setSelectedTest] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [file, setFile] = useState(null);
    const togglePopup = () => setIsOpen(!isOpen);
    const toggleFilePopup = () => setIsFileOpen(!isFileOpen);
    // localStorage.removeItem('answers');

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        // console.log(filters);
        let filteredItems = [...tests];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        const filteredFiles = files.filter(file => {
            const isImage = file.type.startsWith('image/');
            const isValidSize = file.size <= 2 * 1024 * 1024; // 2MB

            return isImage && isValidSize;
        });

        setSelectedFiles(filteredFiles);
    };

    const getTests = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/tests',
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setTests(response.data.tests);
            setFilteredData(response.data.tests);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        localStorage.removeItem('testOrganization');
        localStorage.removeItem('testExam');
        localStorage.removeItem('testQues');
        localStorage.removeItem('testId');
        localStorage.removeItem('examId');
        getTests();
    }, []);

    const viewTest = (uid) => {
        localStorage.setItem('tId', uid);
        navigate('/view_test');

    }
    const userTest = (uid) => {
        localStorage.setItem('tId', uid);
        navigate('/user_test');

    }

    const editTest = (uid) => {
        localStorage.setItem('editTest', uid);
        navigate('/edit_test');

    }

    const scheduleTest = (uid, addedMarks, marks, status) => {
        if (addedMarks === marks) {
            if (status === 'true') {
                localStorage.setItem('scheduleTest', uid);
                navigate('/add_test_schedule');
            }
            else {
                iziToast.error({
                    'message': 'Test is not Approved.',
                    'position': 'topCenter'
                });
            }
        }
        else {
            iziToast.error({
                'message': 'Please prepare all questions first.',
                'position': 'topCenter'
            });
        }

    }

    const deleteTest = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/delete_test', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getTests();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const confirmDeletion = (uid) => {
        iziToast.show({
            color: 'red',
            message: 'Confirm Deletion',
            position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
            buttons: [
                [
                    '<button>Ok</button>',
                    function (instance, toast) {
                        deleteTest(uid);
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ],
                [
                    '<button>Close</button>',
                    function (instance, toast) {
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ]
            ]
        });
    }

    const testStatus = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/test_status', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getTests();
            }

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Process form data
        if (!selectedTest) {
            iziToast.error({
                message: "Please select test",
                position: "topCenter",

            });
            return false;
        }
        if (!file || file === null || file === "") {
            iziToast.error({
                message: "Please select file",
                position: "topCenter",

            });
            return false;
        }
        // console.log('Selected User:', selectedTest);
        // console.log('File:', file);
        // return false;

        const formData = new FormData();
        formData.append('testId', selectedTest);
        formData.append('file', file);
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/import_questions', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            if (response.data.status === "true") {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            // if (response.data.status === "false") {
            //     iziToast.error({
            //         message: response.data.message,
            //         position: "topCenter"
            //     });
            // }
            // else {
            //     iziToast.success({
            //         message: response.data.message,
            //         position: "topCenter"
            //     });
            // }
            setIsOpen(false);
            setFile(null);
            getTests();
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleFileSubmit = async (e) => {
        e.preventDefault();
        // Process form data
        if (!selectedTest) {
            iziToast.error({
                message: "Please select test",
                position: "topCenter",

            });
            return false;
        }
        if (!selectedFiles || selectedFiles === null || !selectedFiles.length) {
            iziToast.error({
                message: "Please select an image file",
                position: "topCenter",

            });
            return false;
        }
        // console.log('Selected User:', selectedTest);
        // console.log('File:', file);
        // return false;

        const formData = new FormData();
        formData.append('testId', selectedTest);
        selectedFiles.forEach(file => {
            formData.append('files', file);
        });
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/upload_images', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            if (response.data.status === "true") {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            setIsFileOpen(false);
            setSelectedFiles(null);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    // Define columns for the table
    const addQuestion = (testId, exmid) => {
        localStorage.setItem('testId', testId);
        localStorage.setItem('examId', exmid);
        navigate('/add_question');
    }
    // <i class="fa fa-file rounded p-1 ml-1 cursor-pointer text-orange-500 hover:text-white border-2 border-orange-500 hover:bg-orange-500" title="attempt test" onClick={() => userTest(row.id)}></i>

    const columns = [
        { name: "Test Name", selector: (row) => row.test_name, sortable: true, },
        { name: "Exam", selector: (row) => row.exam?.exam_name, sortable: true, },
        { name: "Organization", selector: (row) => row.organization?.name, sortable: true, },
        {
            name: "Marks", selector: (row) => <>
                {row.marks_added + "/" + row.marks}
            </>, sortable: true,
        },
        {
            name: "Questions", selector: (row) => <>
                {row.total_questions} {(row.marks_added < row.marks) ? <button onClick={() => addQuestion(row.id, row.exam?.id)} class="rounded p-1 cursor-pointer text-green-600 hover:text-white border-2 border-green-600 hover:bg-green-600">Add</button> : ""}
            </>, sortable: true,
        },
        {
            name: "Status", selector: (row) => <>
                {(userType === 'admin') ? ((row.status === 'true') ? "Verified" : "Un-Verified") : <input type="checkbox" onClick={() => testStatus(row.id)} checked={(row.status === 'true')} title={(row.status === "true") ? 'Active' : 'In-Active'} />}
            </>, sortable: true,
        },
        {
            name: "Action", selector: (row) => <>
                <i class="fa fa-eye rounded p-1 cursor-pointer text-green-600 hover:text-white border-2 border-green-600 hover:bg-green-600" title="view test" onClick={() => viewTest(row.id)}></i>
                <i class="fa fa-edit rounded p-1 ml-1 cursor-pointer text-blue-600 hover:text-white border-2 border-blue-600 hover:bg-blue-600" title="edit test" onClick={() => editTest(row.id)}></i>
                <i class="fa fa-clock rounded p-1 ml-1 cursor-pointer text-orange-600 hover:text-white border-2 border-orange-600 hover:bg-orange-600" title="schedule test" onClick={() => scheduleTest(row.id, row.marks_added, row.marks, row.status)}></i>
                <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white border-2 border-red-600 hover:bg-red-600" title="delete test" onClick={() => confirmDeletion(row.id)}></i>
            </>, sortable: true,
        },
    ];

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
            </span>
            {<Navbar />}
            {isOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
                        <h2 className="text-lg font-semibold mb-4">Import Questions</h2>
                        <Link to={`${filepath}/public/question_word_sample.docx`} download={`question_import_word_sample.docx`} target="_blank" className="text-sm text-blue-500 hover:text-blue-700"><i className="fa fa-download"></i>Word Sample</Link>
                        <Link to={`${filepath}/public/question_excel_sample.xlsx`} download={`question_import_excel_sample.xlsx`} target="_blank" className="text-sm text-blue-500 hover:text-blue-700 ms-2"><i className="fa fa-download"></i>Excel Sample</Link>
                        <form onSubmit={handleSubmit}>
                            {/* Select User */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Test</label>
                                <select
                                    value={selectedTest}
                                    onChange={(e) => setSelectedTest(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Test</option>
                                    {tests.map((org) => {
                                        return (<>
                                            <option value={org.id}>{org.test_name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>

                            {/* Select File */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select File</label>
                                <input
                                    type="file"
                                    accept=".xls,.xlsx,.doc,.docx"
                                    onChange={(e) => { setFile(e.target.files[0]); console.log(e.target.files[0].type); }}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                />
                            </div>

                            <div className="flex justify-end space-x-2">
                                <button
                                    type="button"
                                    onClick={togglePopup}
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {isFileOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
                        <h2 className="text-lg font-semibold mb-4">Upload Question Images</h2>
                        <form onSubmit={handleFileSubmit}>
                            {/* Select User */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Test</label>
                                <select
                                    value={selectedTest}
                                    onChange={(e) => setSelectedTest(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Test</option>
                                    {tests.map((org) => {
                                        return (<>
                                            <option value={org.id}>{org.test_name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>

                            {/* Select File */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select File</label>
                                <small>Only files less then 2MB will be uploaded.</small>
                                <input
                                    type="file"
                                    multiple
                                    accept=".png,.jpg,.jpeg"
                                    onChange={ handleFileChange }
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                />
                            </div>

                            <div className="flex justify-end space-x-2">
                                <button
                                    type="button"
                                    onClick={toggleFilePopup}
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"tests"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                                <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={() => goBack()}></i>Tests</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Exams</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={filters}
                                    onChange={(e) => setFilters(e.target.value)}
                                    className="p-1.5 shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]"
                                />
                                <div className="flex">
                                    <Link to={`/add_test`}><button className="p-1 text-sm font-bold text-teal-800 rounded-lg border-2 border-teal-800 hover:bg-teal-800 hover:text-white hover:border-transparent">
                                        + Add
                                    </button>
                                    </Link>
                                    <button onClick={togglePopup} className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent">
                                        Import Questions
                                    </button>
                                    <button onClick={toggleFilePopup} className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent">
                                        Upload Images
                                    </button>
                                    <Link to={`/test_schedules`}><button className="p-1 ms-3 text-sm font-bold text-orange-600 rounded-lg border-2 border-orange-600 hover:bg-orange-600 hover:text-white hover:border-transparent">
                                        Schedules
                                    </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="max-h-[70vh] overflow-auto shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]">

                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};